import { useCallback } from "react";

import { queryClient } from "../../../services/query";

import { fieldEnrollmentsQueryKeyPrefix } from "./fieldEnrollments.query";

// ###################################
// ## useInvalidateFieldEnrollments ##
// ###################################

export type ResultOfUseInvalidateFieldEnrollments = () => Promise<void>;
export type UseInvalidateFieldEnrollments =
  () => ResultOfUseInvalidateFieldEnrollments;

/**
 * Invalidates the field enrollments data.
 */
export const useInvalidateFieldEnrollments: UseInvalidateFieldEnrollments =
  () => {
    return useCallback(async () => {
      await queryClient.invalidateQueries(fieldEnrollmentsQueryKeyPrefix);
    }, []);
  };

// ##############################
// ## useClearFieldEnrollments ##
// ##############################

export type ResultOfUseClearFieldEnrollments = () => Promise<void>;
export type UseClearFieldEnrollments = () => ResultOfUseClearFieldEnrollments;

/**
 * Clears and invalidates the field enrollments data.
 * A fresh fetch of data will be initiated when a hook instance is active that uses this data.
 */
export const useClearFieldEnrollments: UseClearFieldEnrollments = () => {
  return useCallback(async () => {
    await queryClient.resetQueries(fieldEnrollmentsQueryKeyPrefix);
  }, []);
};
